import { Option } from "@inrev/core";
import { Text } from "@portal/components/primitives";

const DOT_DELAYS_MS = [0, 160, 320];

/**
 * Placeholder for an assistant turn that has not streamed any text yet. Tool calls are hidden,
 * so this is the only signal that the agent is still working.
 */
export const AdminAssistantThinking = ({ progress }: { progress: Option<string> }) => (
	<div
		aria-label={progress ?? "Thinking"}
		className="mt-[1px] flex h-[22px] items-center gap-[3px] text-tertiary"
		data-testid="assistant-thinking"
		role="status"
	>
		{DOT_DELAYS_MS.map((delay) => (
			<span
				className="h-[5px] w-[5px] animate-thinking-dot rounded-full bg-current motion-reduce:animate-none"
				key={delay}
				style={{ animationDelay: `${delay}ms` }}
			/>
		))}
		{Option.isSome(progress) && (
			<Text
				className="ml-1.5"
				color="tertiary"
				data-testid="assistant-tool-progress"
				type="caption"
			>
				{progress}
			</Text>
		)}
	</div>
);
